import { Component, Input, OnInit } from '@angular/core'
import { DailyLogMyProfilePost, DailyLogPostListItem } from 'src/app/interfaces/daily-log'
import { RouterService } from 'src/app/services/router/router.service'
import { getFormattedDate } from 'src/utils/utils'

@Component({
  selector: 'app-profile-log-post',
  templateUrl: './profile-log-post.component.html',
  styleUrls: ['./profile-log-post.component.scss'],
})
export class ProfileLogPostComponent implements OnInit {
  constructor(private routerService: RouterService) {}

  @Input() data: (DailyLogPostListItem & Partial<Pick<DailyLogMyProfilePost, 'viewCount' | 'publicType'>>) | undefined
  @Input() isHost: boolean = false

  get publicTypeTitle(): string {
    if (!this.isHost || !this.data?.publicType) {
      return ''
    }

    return `profile.publicType.${this.data.publicType.toLowerCase()}`
  }

  get day() {
    if (!this.data) {
      return ''
    }
    return getFormattedDate(this.data.postedAt, 'ddd')
  }

  get date() {
    if (!this.data) {
      return ''
    }
    return getFormattedDate(this.data.postedAt, 'YYYY.MM.DD')
  }

  ngOnInit() {}

  onClickPost() {
    if (!this.data) {
      return
    }
    this.routerService.navigate(`daily-log/${this.data.id}`)
  }
}
